<template>
  <div>
    <b-navbar
      toggleable="xl"
      type="light"
      variant="faded"
      class="empire-header fixed-empire-header"
      v-bind:class="[
        langName == 'ar' ? 'er-emp-header er-emp-red-header' : '',
        this.$route.path == '/premiumMenuScanner' ? 'd-none' : '',
      ]"
    >
      <b-navbar-brand
        @click="goToHome"
        style="cursor: pointer"
        v-bind:class="langName == 'ar' ? 'text-right' : ''"
      >
        <img
          src="@/assets/img/new-img/svg-img/new-logo-red.svg"
          width="200px"
          v-if="langName != 'ar'"
        />
        <div v-if="langName == 'ar'">
          <img
            src="@/assets/img/new-img/svg-img/new-logo-ar-red.svg"
            width="200px"
          />
        </div>
      </b-navbar-brand>
      <div class="d-block d-xl-none">
        <div class="d-flex align-items-center justify-content-end">
          <b-navbar-nav>
            <!-- <b-nav-item class="d-flex" v-if="!loggedInFlag">
              <img
                src="@/assets/img/new-img/svg-img/black-login.svg"
                class="image login-img hello1"
              />
              <router-link to="/login"
                >{{ allLanguageData.Login }}
              </router-link>
            </b-nav-item>
            <b-nav-item
              class="d-flex"
              @click="profileDropdownActive()"
              v-if="loggedInFlag"
            >
              <img
                src="@/assets/img/new-img/svg-img/black-login.svg"
                class="image login-img"
              />
              {{ profileDetails.FirstName }}
            </b-nav-item> -->
          </b-navbar-nav>

          <b-nav-item class="d-flex">
            <img
              src="@/assets/img/new-img/svg-img/search-icon.svg"
              width="30px"
              height="auto"
              v-on:click="openSearch(true)"
              class="search-icon"
            />
          </b-nav-item>
          <div class="pl-2">
            <img
              src="@/assets/img/svg/nav-toggler-black.svg"
              @click="showMenu"
            />
          </div>
        </div>
        <b-nav-item-dropdown
          right
          class="custom-dropdown menu-border-right cinema-dropdown mobile-cinema-dropdown"
        >
          <template slot="button-content">
            <span class="text-truncate">{{
              getSelectedBrijCinemas.cinema_name
                ? getCinemaTranslatedName(getSelectedBrijCinemas)
                : allLanguageData.AllCinemas
            }}</span>
          </template>
          <b-dropdown-item
            v-on:click="saveSelectedCinemaBrij(cinema)"
            v-for="(cinema, Index) in getBrijCinemas"
            :key="Index"
            class="text-truncate"
            :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
            >{{ getCinemaTranslatedName(cinema) }}
          </b-dropdown-item>

          <!-- <b-dropdown-item href="#">JEDDAH</b-dropdown-item>
          <b-dropdown-item href="#">KHOBAR</b-dropdown-item> -->
        </b-nav-item-dropdown>
      </div>
      <!--Start Desktop Bar--->
      <b-collapse id="nav-collapse" class="d-none d-lg-none d-xl-block" is-nav>
        <b-navbar-nav class="ml-auto align-items-center empire-navbar-header">
          <b-nav-item class="">
            <div class="menu-country" @click="openLandingpage()">
              <img
                v-if="country_id == '230'"
                src="@/assets/img/SaudiArabiaFlag.png"
                class="image"
              />
              <img
                v-else-if="country_id == '121'"
                src="@/assets/img/LebanonFlag.png"
                class="image"
              />
              <img
                v-else-if="country_id == '102'"
                src="@/assets/img/IraqFlag.png"
                class="image"
              />
              <img
                v-else
                src="@/assets/img/SaudiArabiaFlag.png"
                class="image"
              />
              <span class="countryname">{{ CountryName }}</span>
            </div>
          </b-nav-item>
          <b-nav-item-dropdown
            right
            class="custom-dropdown menu-border-right cinema-dropdown ml-n2"
          >
            <template slot="button-content">
              <span class="text-truncate">{{
                getSelectedBrijCinemas.cinema_name
                  ? getCinemaTranslatedName(getSelectedBrijCinemas)
                  : allLanguageData.AllCinemas
              }}</span>
            </template>
            <b-dropdown-item
              v-on:click="saveSelectedCinemaBrij(cinema)"
              v-for="(cinema, Index) in getBrijCinemas"
              :key="Index"
              class="text-truncate"
              :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
            >
              {{ getCinemaTranslatedName(cinema) }}
            </b-dropdown-item>

            <!-- <b-dropdown-item href="#">JEDDAH</b-dropdown-item>
            <b-dropdown-item href="#">KHOBAR</b-dropdown-item> -->
          </b-nav-item-dropdown>
          <hr class="vertical" />
          <b-nav-item class="">
            <router-link to="/">{{ allLanguageData.Home }} </router-link>
          </b-nav-item>
          <b-nav-item class="menu-item">
            <router-link to="/allCinemashowtimes"
              >{{ allLanguageData.ShowTime }}
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="country_id == '230'" class="menu-item">
            <router-link :to="'/clubEmpire'"
              >{{ allLanguageData.Loyalty.club_empire_txt }}
            </router-link>
          </b-nav-item>
          <b-nav-item class="menu-item">
            <router-link to="/private-booking" exact
              >{{ allLanguageData.PrivateBooking }}
            </router-link>
          </b-nav-item>
          <b-nav-item class="menu-item">
            <router-link to="/premiere/9/premiere" exact
              >{{ allLanguageData.Premiere }}
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="country_id == '230'" class="menu-item">
            <router-link
              :class="[
                String($route.path).startsWith('/screenx')
                  ? 'router-link-exact-active router-link-active'
                  : '',
              ]"
              to="#"
              @click.native="goToExperiences"
              >{{ allLanguageData.Experiences }}
            </router-link>
          </b-nav-item>
          <b-nav-item class="menu-item">
            <router-link to="/location"
              >{{ allLanguageData.Branches }}
            </router-link>
          </b-nav-item>
          <b-nav-item-dropdown
            v-if="country_id == '230'"
            right
            class="custom-dropdown menu-item"
          >
            <template slot="button-content">
              {{ allLanguageData.FoodDrinks }}
            </template>
            <b-dropdown-item
              @click="goToMenu"
              :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
            >
              {{ allLanguageData.OurMenu }}
            </b-dropdown-item>

            <b-dropdown-item
              @click="goToPremiere"
              :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
            >
              {{ allLanguageData.Premiere }}
            </b-dropdown-item>
            <!-- <b-dropdown-item
              ><router-link to="/order-online"
                >order online</router-link
              ></b-dropdown-item
            > -->
          </b-nav-item-dropdown>
          <b-nav-item v-if="country_id == '230'" class="">
            <router-link to="/cinema-offer"
              >{{ allLanguageData.Offers }}
            </router-link>
          </b-nav-item>

          <b-nav-item class="menu-item">
            <router-link to="/getApp"
              >{{ allLanguageData.GetApp }}
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="menu-border align-items-center">
          <hr class="vertical" />
          <b-nav-item
            v-on:click="
              saveLangToken('eng', 2, { brij_lang_id: 1, iso_2: 'en' })
            "
            v-bind:class="langName != 'ar' ? 'active' : ''"
          >
            EN
            <!-- {{ langName === "ar" ? "ان" : "EN" }} -->
          </b-nav-item>
          <b-nav-item
            v-on:click="
              saveLangToken('ar', 1, { brij_lang_id: 3, iso_2: 'ar' })
            "
            v-bind:class="langName == 'ar' ? 'active' : ''"
            class="menu-item"
          >
            <!-- AR -->
            عربي
          </b-nav-item>
          <hr class="vertical" />
        </b-navbar-nav>
        <b-navbar-nav class="align-items-center">
          <b-nav-item class="d-flex">
            <img
              src="@/assets/img/new-img/svg-img/search-icon.svg"
              width="30px"
              height="auto"
              v-on:click="openSearch(true)"
              class="search-icon"
            />
          </b-nav-item>

          <b-nav-item
            class="d-flex"
            v-if="!loggedInFlag && country_id == '230'"
          >
            <router-link to="/login">
              <img
                src="@/assets/img/new-img/svg-img/black-login.svg"
                class="image login-img"
              />
              {{ allLanguageData.Login }}
            </router-link>
          </b-nav-item>
          <b-nav-item
            class="d-flex logged-user"
            @click="profileDropdownActive()"
            v-if="loggedInFlag && false"
          >
            <!-- <img
              src="@/assets/img/new-img/svg-img/black-login.svg"
              class="image login-img"
            /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 17.92 27.82"
              height="27px"
              fill="#434345"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M3.75.16A.23.23,0,0,1,3.89,0a.36.36,0,0,1,.19.08.94.94,0,0,1,.16.23l.28.42L5.57,2.37l.32.49L6,3.09h0a1.34,1.34,0,0,1,.07-.18l.16-.4c.26-.61.52-1.21.77-1.82C7.13.54,7.27,0,7.51,0s.36.52.44.69c.33.79.67,1.57,1,2.35H9c.35-.8.7-1.61,1-2.42.07-.15.22-.68.47-.63s.34.56.42.72c.32.78.65,1.56,1,2.35h0C12.43,2.25,13,1.42,13.51.58c.08-.12.4-.76.62-.53a.29.29,0,0,1,0,.21c-.1.49-.21,1-.31,1.46-.22,1.07-.45,2.13-.67,3.19-.09.4-.17.79-.25,1.19a2.71,2.71,0,0,0-.1.51h0s-.06,0-.09,0H9.21a.62.62,0,0,0-.24,0H6.12a6.45,6.45,0,0,1-1,0A.94.94,0,0,1,5,6.3l-.21-1C4.55,4.06,4.28,2.8,4,1.53l-.21-1A1.08,1.08,0,0,1,3.75.16Z"
                  />
                  <circle class="cls-1" cx="8.96" cy="13.94" r="5.83" />
                  <path
                    class="cls-1"
                    d="M17.92,27.75S0,27.91,0,27.75V26.13c0-2.66,3.79-4.82,8.42-4.82H9.51c4.63,0,8.41,2.16,8.41,4.82Z"
                  />
                </g>
              </g>
            </svg>
            {{ profileDetails.FirstName }}
          </b-nav-item>

          <div class="d-flex" v-if="loggedInFlag">
            <img
              v-if="!loggedInFlag"
              src="@/assets/img/new-img/svg-img/black-login.svg"
              class="image login-img"
            />
            <template v-if="loggedInFlag">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17.92 27.82"
                height="27px"
                fill="#CF1F2E"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      class="cls-1"
                      d="M3.75.16A.23.23,0,0,1,3.89,0a.36.36,0,0,1,.19.08.94.94,0,0,1,.16.23l.28.42L5.57,2.37l.32.49L6,3.09h0a1.34,1.34,0,0,1,.07-.18l.16-.4c.26-.61.52-1.21.77-1.82C7.13.54,7.27,0,7.51,0s.36.52.44.69c.33.79.67,1.57,1,2.35H9c.35-.8.7-1.61,1-2.42.07-.15.22-.68.47-.63s.34.56.42.72c.32.78.65,1.56,1,2.35h0C12.43,2.25,13,1.42,13.51.58c.08-.12.4-.76.62-.53a.29.29,0,0,1,0,.21c-.1.49-.21,1-.31,1.46-.22,1.07-.45,2.13-.67,3.19-.09.4-.17.79-.25,1.19a2.71,2.71,0,0,0-.1.51h0s-.06,0-.09,0H9.21a.62.62,0,0,0-.24,0H6.12a6.45,6.45,0,0,1-1,0A.94.94,0,0,1,5,6.3l-.21-1C4.55,4.06,4.28,2.8,4,1.53l-.21-1A1.08,1.08,0,0,1,3.75.16Z"
                    />
                    <circle class="cls-1" cx="8.96" cy="13.94" r="5.83" />
                    <path
                      class="cls-1"
                      d="M17.92,27.75S0,27.91,0,27.75V26.13c0-2.66,3.79-4.82,8.42-4.82H9.51c4.63,0,8.41,2.16,8.41,4.82Z"
                    />
                  </g>
                </g>
              </svg>
            </template>

            <b-nav-item-dropdown
              :text="profileDetails.FirstName"
              class="d-flex logged-user"
              @click="profileDropdownActive()"
              left
            >
              <template>
                <div
                  ref="dropdown"
                  class="new-emp-dropdown active"
                  :class="isProfileDropdownActive ? 'active' : ''"
                >
                  <ul class="list-unstyled mb-0">
                    <li class="text-center pb-0 no-hover-effect">
                      <img
                        v-if="profileDetails.ProfileImage"
                        :src="profileDetails.ProfileImage"
                        height="65px"
                        width="60px"
                        class="rounded-circle"
                        alt=""
                      />
                      <img
                        v-else
                        src="@/assets/img/newImages/profile-placeholder-white.svg"
                        height="65px"
                        width="60px"
                        alt=""
                      />
                      <h6 class="py-3 my-0 text-uppercase">
                        {{ profileDetails.FirstName }}
                      </h6>
                    </li>

                    <li class="no-hover-effect p-0">
                      <hr class="m-0 fade-line no-hover-effect" />
                    </li>

                    <!-- <li @click.prevent="changeProfileTabs('clubEmpire')">
            MyClubEmpirePonts
          </li> -->
                    <li
                      v-if="userDetails.isUPPLoyaltySubscribe == 'N'"
                      @click.prevent="loyaltyhowitWorks()"
                    >
                      {{ allLanguageData.MyClubEmpire }}
                    </li>

                    <li v-else @click.prevent="changeProfileTabs('clubEmpire')">
                      {{ allLanguageData.MyClubEmpire }}
                    </li>
                    <li class="no-hover-effect p-0">
                      <hr class="m-0 fade-line no-hover-effect" />
                    </li>
                    <li @click.prevent="changeProfileTabs('booking')">
                      {{ allLanguageData.MyBooking }}
                    </li>

                    <li class="no-hover-effect p-0">
                      <hr class="m-0 fade-line no-hover-effect" />
                    </li>

                    <li @click.prevent="changeProfileTabs('account')">
                      {{ allLanguageData.MyAccount }}
                    </li>

                    <li class="no-hover-effect p-0">
                      <hr class="m-0 fade-line no-hover-effect" />
                    </li>

                    <li @click.prevent="changeProfileTabs('preferencess')">
                      {{ allLanguageData.MyPreferencess }}
                    </li>

                    <li class="no-hover-effect p-0">
                      <hr class="m-0 fade-line no-hover-effect" />
                    </li>
                    <li class="" v-on:click.stop="onUserLogout()">
                      {{ allLanguageData.Logout }}
                    </li>
                  </ul>
                </div>
              </template>
              <!-- <b-dropdown-item href="#">EN</b-dropdown-item>
              <b-dropdown-item href="#">ES</b-dropdown-item>
              <b-dropdown-item href="#">RU</b-dropdown-item>
              <b-dropdown-item href="#">FA</b-dropdown-item> -->
            </b-nav-item-dropdown>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!--End Desktop Bar-->
    <!--Start Mobile Menu--->
    <aside
      class="mobile-menu"
      :class="
        isMobileMenu
          ? 'show-menu'
          : '' || this.$route.path == '/Vip-Menu'
          ? 'd-none'
          : ''
      "
    >
      <div class="mob-header px-3">
        <div class="d-flex align-items-center justify-content-between pt-4">
          <a class="m-logo" href="/">
            <!-- <img src="@/assets/img/svg/Empire-logo-e.svg" /> -->
            <img
              src="@/assets/img/new-img/svg-img/new-logo-white.svg"
              width="200px"
              v-if="langName != 'ar'"
            />
            <img
              src="@/assets/img/new-img/svg-img/new-logo-ar-white.svg"
              width="200px"
              v-if="langName == 'ar'"
            />
          </a>
          <div>
            <img
              src="@/assets/img/new-img/svg-img/left-white-arrow.svg"
              width="40px"
              @click="hideMenu"
              class="pl-3"
            />
          </div>
        </div>
      </div>
      <div>
        <ul class="mob-side-list mt-5">
          <li v-if="!loggedInFlag && country_id == '230'">
            <a
              href="/login"
              class="router-link-exact-active router-link-active"
            >
              <!-- {{ allLanguageData.Login }} -->
              {{ allLanguageData.CommonModalInputs.SignIn }} /
              {{ allLanguageData.CommonModalInputs.SignUp }}
            </a>
          </li>
          <li class="login-collapse" v-if="loggedInFlag">
            <a href="/profile">
              <div>
                <img
                  src="@/assets/img/new-img/svg-img/black-login.svg"
                  class="m-login-img"
                />
              </div>
              <div class="login-name">
                {{ profileDetails.FirstName }}
              </div>
            </a>
            <div class="" v-on:click.stop="onUserLogout()">
              {{ allLanguageData.Logout }}
            </div>
          </li>
          <!-- <b-collapse id="collapse-2">
            <li @click.prevent="changeProfileTabs('booking')">MY BOOKING</li>
            <li class="no-hover-effect p-0">
              <hr class="m-0 fade-line no-hover-effect" />
            </li>
            <li @click.prevent="changeProfileTabs('account')">MY ACCOUNT</li>
            <li class="no-hover-effect p-0">
              <hr class="m-0 fade-line no-hover-effect" />
            </li>
            <li @click.prevent="changeProfileTabs('preferencess')">
              MyPreferences
            </li>
            <li class="no-hover-effect p-0">
              <hr class="m-0 fade-line no-hover-effect" />
            </li>
            <li class="" v-on:click.stop="onUserLogout()">LOG OUT</li>
          </b-collapse> -->
          <!-- <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li> -->
          <!-- <li>
            <a href="/" class="router-link-exact-active router-link-active">{{
              allLanguageData.Home
            }}</a>
          </li> -->
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li>
            <a href="/allCinemashowtimes" class="">
              {{ allLanguageData.ShowTime }}
            </a>
          </li>
          <li v-if="country_id == '230'" class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li>
            <a href="/private-booking" exact
              >{{ allLanguageData.PrivateBooking }}
            </a>
          </li>
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li>
            <a href="/premiere/9/premiere" exact
              >{{ allLanguageData.Premiere }}
            </a>
          </li>
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li v-if="country_id == '230'" @click.stop.prevent="goToExperiences">
            <a style="color: #fff !important;">
              {{ allLanguageData.Experiences }}
            </a>
          </li>
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li>
            <a href="/location" class="">
              {{ allLanguageData.Branches }}
            </a>
          </li>
          <li v-if="country_id == '230'" class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li
            v-if="country_id == '230'"
            v-b-toggle.collapse-1
            class="custom-collapse"
            style="color: #fff !important;"
          >
            {{ allLanguageData.FoodDrinks }}
          </li>
          <b-collapse id="collapse-1">
            <li>
              <a href="/menu" class="">
                {{ allLanguageData.OurMenu }}
              </a>
            </li>
            <li>
              <a href="/premiere" class="">{{ allLanguageData.Premiere }}</a>
            </li>
          </b-collapse>
          <li v-if="country_id == '230'" class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li v-if="country_id == '230'">
            <a href="/cinema-offer" class="">
              {{ allLanguageData.Offers }}
            </a>
          </li>
          <li v-if="country_id == '230'" class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li v-if="country_id == '230'">
            <a :href="!loggedInFlag ? '/login' : '/clubEmpire'" class="">
              {{ allLanguageData.Loyalty.club_empire_txt }}
            </a>
          </li>
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li>
            <a href="/getApp" class=""> {{ allLanguageData.GetApp }} </a>
          </li>
          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
        </ul>
      </div>
      <div class="mob-footer">
        <div class="d-flex align-items-center justify-content-start">
          <div class="menu-country" @click="openLandingpage()">
            <img
              v-if="country_id == '230'"
              src="@/assets/img/SaudiArabiaFlag.png"
              class="image"
            />
            <img
              v-else-if="country_id == '121'"
              src="@/assets/img/LebanonFlag.png"
              class="image"
            />
            <img
              v-else-if="country_id == '102'"
              src="@/assets/img/IraqFlag.png"
              class="image"
            />
            <img v-else src="@/assets/img/SaudiArabiaFlag.png" class="image" />
          </div>
          <div class="text mb-0 font-weight-bold">
            {{ CountryName }} -

            <li
              v-if="country_id == '230'"
              v-b-toggle.collapse-2
              class="language_custom_collapse"
            >
              {{ langName && langName == "eng" ? "English" : "Arabic" }}
            </li>
            <b-collapse id="collapse-2">
              <li
                style="list-style-type: none"
                v-on:click="
                  saveLangToken('eng', 2, { brij_lang_id: 1, iso_2: 'en' })
                "
                :style="langName != 'ar' ? 'color:#ce1f2e' : ''"
              >
                English
              </li>
              <li
                style="list-style-type: none"
                v-on:click="
                  saveLangToken('ar', 1, { brij_lang_id: 3, iso_2: 'ar' })
                "
                :style="langName == 'ar' ? 'color:#ce1f2e' : ''"
              >
                Arabic
              </li>
            </b-collapse>
          </div>
        </div>
      </div>
    </aside>
    <!--End Mobile Menu--->
    <div class="">
      <!--Old Design Start-->
      <div
        ref="dropdown"
        class="new-emp-dropdown"
        :class="isProfileDropdownActive ? 'active' : ''"
      >
        <ul class="list-unstyled mb-0">
          <li class="text-center pb-0 no-hover-effect">
            <img
              v-if="profileDetails.ProfileImage"
              :src="profileDetails.ProfileImage"
              height="65px"
              width="60px"
              class="rounded-circle"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/newImages/profile-placeholder-white.svg"
              height="65px"
              width="60px"
              alt=""
            />
            <h6 class="py-3 my-0 text-uppercase">
              {{ profileDetails.FirstName }}
            </h6>
          </li>

          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>

          <!-- <li @click.prevent="changeProfileTabs('clubEmpire')">
            MyClubEmpirePonts
          </li> -->

          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>

          <li @click.prevent="changeProfileTabs('booking')">
            {{ allLanguageData.MyBooking }}
          </li>

          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>

          <li @click.prevent="changeProfileTabs('account')">
            {{ allLanguageData.MyAccount }}
          </li>

          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>

          <li @click.prevent="changeProfileTabs('preferencess')">
            {{ allLanguageData.MyPreferencess }}
          </li>

          <li class="no-hover-effect p-0">
            <hr class="m-0 fade-line no-hover-effect" />
          </li>
          <li class="" v-on:click.stop="onUserLogout()">
            {{ allLanguageData.Logout }}
          </li>
        </ul>
      </div>

      <!--Old Design Ends-->
    </div>

    <!-- SEARCH BAR SECTION -->
    <section
      class="search-section animate__animated animate__fadeInUp"
      v-if="displaySearch"
    >
      <div class="container">
        <div class="search-close-arrow">
          <img
            src="@/assets/img/new-img/svg-img/left-black-arrow.svg"
            width="40px"
            @click="openSearch(false)"
            class="pl-3"
          />
        </div>
        <div class="d-flex">
          <input
            type="text"
            @input="searchData"
            v-model="searchValue"
            placeholder="Search For Movie"
          />
          <button
            @click="clearSearch"
            class="close-search search-close-btn font-weight-bold"
          >
            CLEAR
          </button>
        </div>
        <div class="search-results mt-4">
          <div
            class="mt-3"
            v-for="(movie, index) in movieListSearch.length > 0
              ? movieListSearch
              : movieListSearch"
            :key="index"
          >
            <div class="grid-half" @click="goToMovieDetails(movie)">
              <div>
                <img
                  v-if="
                    checkBaseUrl(
                      getLangSpecificAttribute(
                        movie.altMovieContent,
                        getCurrentLang().brij_lang_id,
                        'artwork'
                      ) || movie.artwork
                    )
                  "
                  :src="
                    checkBaseUrl(
                      getLangSpecificAttribute(
                        movie.altMovieContent,
                        getCurrentLang().brij_lang_id,
                        'artwork'
                      ) || movie.artwork
                    )
                  "
                  class="movie-img"
                  onerror="javascript:this.src='/static/img/default-Img.png'"
                />
                <img
                  v-else
                  src="@/assets/img/new-img/png-img/default-Img.png"
                  class="movie-img"
                />
              </div>
              <div class="m-g-half">
                <div class="title">
                  {{
                    getLangSpecificAttribute(
                      movie.altMovieContent,
                      getCurrentLang().brij_lang_id,
                      "mc_title"
                    ) ||
                      movie.movie_title ||
                      movie.original_title_of_movie ||
                      "MOVIE NAME"
                  }}
                </div>
                <div class="tags">
                  {{ movie.rated || movie.rating }} | {{ movie.lang_name }}
                </div>
              </div>
            </div>
            <div>
              <img
                src="@/assets/img/new-img/svg-img/vertical-line.svg"
                class="image img-fluid"
              />
            </div>
          </div>

          <div
            v-if="
              movieListSearch.length == 0 && this.searchValue != movieListSearch
            "
          >
            <div class="d-flex justify-content-center">
              <h4>No Movies Found</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import axios from "axios";
import $ from "jquery";
import { URL_BASE } from "@/helper/constant.js";

import {
  CountryService,
  LanguageService,
  TokenService,
} from "@/services/storage.service";
import { EventBus } from "@/main";
import Vue from "vue";

export default {
  data() {
    return {
      URL_BASE: URL_BASE + "/",
      otp: null,
      isDisabled: false,
      isError: false,
      shouldResetOTP: false,
      isProfileDropdownActive: false,
      isMobileMenu: false,
      submitText: "SUBMIT",
      signupTab: false,
      isSendOtpClicked: false,
      isCheckOtpValid: false,
      isResendOtp: false,
      otpResponse: "",
      phoneNumberErr: false,
      emailErr: false,
      otpErr: false,
      checkoutShow: false,
      otp: {
        value: null,
      },
      verified: {
        phoneNumber: null,
        Email: null,
        countryCode: null,
      },
      loginTab: true,
      text: "",
      newmodalShow: true,
      languageData: {},
      country_id: "",
      lang: "eng",
      showCards: true,
      hideCards: false,
      profileDetails: {},
      UserRecords: {},
      overlay: false,
      countryCode: "",
      openAside: "-320px",
      displaySearch: false,
      hideSearch: "-100vh",
      fbSignInParams: {
        scope: "email",
        return_scopes: false,
      },
      googleSignInParams: {
        client_id:
          // "608518206441-vmd0dou7gia9nsq9vkc7ps38bccsc1so.apps.googleusercontent.com"
          // "193276772057-94fl0er49a467hjm0m1jmpnm7ondunjf.apps.googleusercontent.com"
          // "556054411694-g74ogb6nm2p0257ri8ci4i8an7064ct8.apps.googleusercontent.com"
          "778651711885-p2be0lt57lnk6gfsl5hoo57u11er94la.apps.googleusercontent.com",
      },
      birthDate: {
        date1: "Date",
        month: "Month",
        year: "Year",
      },
      contactUsDeatils: {
        Name: "",
        Mobile: "",
        Email: "",
        Message: "",
        errorMessage: "",
      },
      months: [
        "Jan",
        "Febr",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      years: [],
      selectedCountry: "",
      loggedInFlag: false,
      countries: [],
      country: "",
      city: "",
      countrySelected: "",
      citySelected: "",
      onScroll: true,
      forgotPasswordSection: 0,
      page: "",
      cityDropDown: false,
      searchValue: "",
      movieListSearch: [],
      mobileSearch: false,
      searchQuery: "",
      options: {
        placeholder: "Search",
        inputClass: "header-input-box form-control",
        inputMainClass: "header-input-box form-control",
      },
      mobileOptions: {
        placeholder: "Search",
        inputClass: "sb-search-input",
        inputMainClass: "",
      },
      resErrorMessage: {
        signUpError: "",
        signInError: "",
      },
      loginErrorMessage: "Please Enter Your Credentials",
      registerErrorMessage: "ENTER CONTACT INFORMATION",
      errorMessageStatus: {
        userName: false,
        email: false,
        phoneNumber: false,
        password: false,
        conditions: false,
      },
      classFlag: {
        onSignUp: "",
        onOTP: "",
        otpComplete: "",
        onSignIn: "",
      },
      // User Details
      userDetails: {
        selectedCard: "VisaMaster",
        redirectURL: "/RedirectPayment",
        termsAndConditions: true,
        acceptedTerms: true,
        errorMessage: "",
        confirmEmail: "",
        username: "",
        password: "",
        firstName: "",
        gender: "Gender",
        lastName: "",
        email: "",
        phoneNumber: "",
        confirmedPassword: "",
        countryCode: "966",
        OTP: "",
        newslatteremempirecinemanotification1: 0,
        Status: true,
        userID: null,
        isUPPLoyaltySubscribe: "",
      },
      offerFilterTabs: [],
      NewOTP: "",
      promotionData: {},
      modal: {
        signUp: {
          info: true,
          OTP: false,
        },
        signIn: {
          info: true,
          OTP: false,
        },
      },
      LanguageID: "",
      errorMessage: {
        login: "",
        forgotpassword: "",
        signUp: "",
        checkout: "",
      },
      socialLoginError: {
        error: "",
      },
      IsActivedrop: false,
      loginData: {
        loginInput: {
          email: "",
          password: "",
          conditions: false,
        },
        errorMessageStatus: {
          email: false,
          password: false,
          conditions: false,
        },
        button: true,
      },
      langName: "eng",
      preimere: false,
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      handleCheckout: false,
      errorDob: "",
      errorGender: "",

      // new
      cinemaList: [],
      nowPlayingMoviesArray: [],
      selectedCinema: window.localStorage.getItem("headerCinema"),
      selectedCinemaID: window.localStorage.getItem("headerCinemaID"),
    };
  },
  watch: {
    $route(to, from) {
      let lang = LanguageService.getLanguage();
      let langName = "eng";
      if (lang == null) {
        langName = "eng";
      } else {
        langName = lang["lang"];
      }
      if (langName == "ar") {
        document.body.classList.add("rtl-class");
      } else {
        document.body.classList.remove("rtl-class");
      }
    },
    userLogedInCheck: {
      handler: function(newVal, oldVal) {
        if (this.userLogedInCheck && this.userLogedInCheck == true) {
          this.getUserDetails();
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.countryCode = window.localStorage.getItem("country")
      ? JSON.parse(window.localStorage.getItem("country")).CountryID
      : 230;
    this.CountryName =
      window.localStorage.getItem("CountryName") || "Select Country";
    this.getGeoLocation();
    // get lang token, set value in data
    let token = TokenService.getToken();
    if (token) {
      this.getUserDetails();
    }
    this.checkToken();
    for (var i = new Date().getFullYear(); i > 1900; i--) {
      this.years.push(i);
    }
    let lang = LanguageService.getLanguage();
    let langName = "eng";
    if (window.location.host.includes("premiere")) {
      window.localStorage.setItem("PREIMERE", true);
    }
    if (lang == null) {
      // langName = "eng";
      // window.location.pathname = "/landingpage"1;
    } else {
      langName = lang["lang"];
    }
    this.langName = langName;
    if (window.location.host == "empirepremiere.com") {
      this.country_id = 119;
    } else if (window.location.host == "ksa.empirecinemas.com") {
      this.country_id = 230;
    } else if (window.location.host == "irq.empirecinemas.com") {
      this.country_id = 102;
    } else if (
      window.location.host == "lb-website.brij.tech" ||
      window.location.host == "https://lb.empirecinemas.com/"
    ) {
      this.country_id = 121;
    } else {
      this.country_id = 230;
    }
    this.fetchCinemaList();

    if (!localStorage.getItem("guest_user_id")) {
      localStorage.setItem(
        "guest_user_id",
        Math.floor(Math.random() * 9000000000)
      );
    }
  },
  mounted: function() {
    let language = LanguageService.getLanguage();
    if (!language) {
      this.LanguageID = 2;
    } else {
      this.LanguageID = language.lang_id;
    }
    // this.getAllOffers();
    // this.getPromotionList();
    this.preimere = window.localStorage.getItem("PREIMERE");
    this.selectedCountry =
      window.localStorage.getItem("CountryName") || "LEBANON";

    if (this.langName == "ar") {
      document.body.classList.add("rtl-class");
      document.documentElement.setAttribute("lang", "ar");
    } else if (this.langName == "eng") {
      document.documentElement.setAttribute("lang", "en");
      document.body.classList.remove("rtl-class");
    }
    EventBus.$on("getUserDetailsAndCheckout", (user) => {
      this.checkoutFlag = true;
      this.handleCheckout = true;
      this.checkoutProcess();
      this.getCountryCode();
    });
    EventBus.$on("UserLogin", () => {
      this.checkToken();
    });
    EventBus.$on("isUserNotLogin", () => {
      //  this.$bvModal.show('login')
      this.$refs.signInModal.show();
    });
    // sessionTimeOut
    EventBus.$on("updateProfile", (userName) => {
      this.profileDetails.FirstName = userName;
    });
    // EventBus.$on("hideGuestCheckout", () => {
    //   this.handleCheckout = false;
    // });
  },
  computed: {
    brij_country_id() {
      return String(
        this.getSafe(() => CountryService.getCountry().country_id, "0")
      );
    },
    // filteredList: function() {
    //   this.movieListSearch.filter((a) => {
    //     return a.movie_title.match(this.searchValue);
    //   });
    // },

    tooltipText: function() {
      // put your logic here to change the tooltip text
      return this.$refs.dropdown;
    },

    allMovies() {
      let nowShowing = this.$store.getters.getNowShowing.data || [];
      let upcoming = this.$store.getters.getUpcoming.data || [];

      let data = [
        ...new Map([
          ...nowShowing.map((item) => [item["movie_id"], item]),
          ...upcoming.map((item) => [item["movie_id"], item]),
        ]).values(),
      ];

      return data;
    },
    getUpcoming() {
      return this.$store.getters.getUpcoming.data || [];
    },
    getNowShowing() {
      return this.$store.getters.getNowShowing.data || [];
    },
    userLogedInCheck() {
      return this.$store.state.headerCinemaStore.userLogedIn;
    },
    getBrijCinemas() {
      return [
        {
          cinema_id: "",
          cinema_name: "All",
          cinema_code: "All",
          CinemaName: "ALL CINEMAS",
          CinemaID: "ALL",
          translation_data: [
            {
              langaugeId: 3,
              langauge: "Arabic",
              iso_2: "AR",
              iso_3: "ARA",
              cinema_name: "كل الفروع",
              cinema_address: "",
              cinema_location: "",
            },
          ],
        },
        ...(this.$store.getters.getBrijCinemas
          ? this.$store.getters.getBrijCinemas.sort((a, b) =>
              a.cinema_name.localeCompare(b.cinema_name)
            )
          : []),
      ];
    },

    getBrijCountries() {
      return this.$store.getters.getBrijCountries;
    },
    getSelectedBrijCinemas() {
      return this.$store.getters.getSelectedBrijCinemas;
    },
    getExperiencesBrij() {
      return this.$store.getters.getExperiences;
    },
  },
  methods: {
    SearchMovieData(movieList = [], index, searchType, searchedQuery) {
      if (!searchedQuery) return movieList || [];

      let searchedResult = [];

      try {
        searchedResult = movieList.filter((x) => {
          if (
            x.movie_title &&
            x.movie_title.toLowerCase().includes(searchedQuery.toLowerCase())
          ) {
            return x;
          }

          // if (
          //   x.d_company_name && x.d_company_name.toLowerCase().includes(searchedQuery.toLowerCase())
          // ) {
          //   return x
          // }

          // if (
          //   x.alternate_movie_name_language &&
          //   x.alternate_movie_name_language
          //     .toLowerCase()
          //     .includes(searchedQuery.toLowerCase())
          // ) {
          //   return x;
          // }

          // if (
          //   x.languageSpecificImages &&
          //   x.languageSpecificImages.length > 0 &&
          //   x.languageSpecificImages.some((mc) =>
          //     mc.mc_title.toLowerCase().includes(searchedQuery.toLowerCase())
          //   )
          // ) {
          //   return x;
          // }

          if (
            x.genres_with_translations &&
            x.genres_with_translations.length > 0 &&
            x.genres_with_translations.some(
              (g) =>
                this.getSafe(() =>
                  g.en.toLowerCase().includes(searchedQuery.toLowerCase())
                ) ||
                this.getSafe(() =>
                  g.ar.toLowerCase().includes(searchedQuery.toLowerCase())
                ) ||
                g.g_name.toLowerCase().includes(searchedQuery.toLowerCase())
            )
          ) {
            return x;
          }

          // if (
          //   x.languages_with_translations &&
          //   x.languages_with_translations.length > 0 &&
          //   x.languages_with_translations.some(
          //     (l) =>
          //       this.getSafe(() =>
          //         l.en.toLowerCase().includes(searchedQuery.toLowerCase())
          //       ) ||
          //       this.getSafe(() =>
          //         l.ar.toLowerCase().includes(searchedQuery.toLowerCase())
          //       ) ||
          //       l.lang_name.toLowerCase().includes(searchedQuery.toLowerCase())
          //   )
          // ) {
          //   return x;
          // }

          // if (
          //   x.label_to_show &&
          //   x.label_to_show.length > 0 &&
          //   x.label_to_show.some(label => this.getSafe(() => label.label_name.toLowerCase().includes(searchedQuery.toLowerCase())))
          // ) {
          //   return x
          // }

          // if (
          //   x.label_to_show &&
          //   x.label_to_show.length > 0 &&
          //   x.label_to_show.some(label => this.getSafe(() => label.label.toLowerCase().includes(searchedQuery.toLowerCase())))
          // ) {
          //   return x
          // }

          // if (
          //   x.category_link_name && x.category_link_name.toLowerCase().includes(searchedQuery.toLowerCase())
          // ) {
          //   return x
          // }

          // if (
          //   x.language_content &&
          //   x.language_content.length > 0 &&
          //   x.language_content.some(label => label.event_name.toLowerCase().includes(searchedQuery.toLowerCase()))
          // ) {
          //   return x
          // }

          // if (
          //   x.cast_crew.length &&
          //   x.cast_crew.length > 0 &&
          //   x.cast_crew.some(cast => cast.toLowerCase().includes(searchedQuery.toLowerCase()))
          // ) {
          //   return x
          // }

          // if (
          //   x.keywords_list &&
          //   x.keywords_list.length > 0 &&
          //   x.keywords_list.some(key_w => key_w.toLowerCase().includes(searchedQuery.toLowerCase()))
          // ) {
          //   return x
          // }
        });
      } catch (e) {
        searchedResult = movieList;
      }

      // avoid mutating redux state
      // if (window.structuredClone) {
      //   searchedResult = window.structuredClone(searchedResult)
      // }

      searchedResult.forEach((r) => {
        r.searchType = searchType;
      });
      return searchedResult;
    },
    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          "cinema_name",
          "langaugeId"
        ) || cinema.cinema_name;

      return name;
    },
    goToExperiences() {
      this.hideMenu();

      let data = this.$store.getters.getExperiences[0];
      this.$router.push({
        path: `/screenx/${data.ID}/${data.name
          .toLowerCase()
          .replace(/ /g, "-")}`,
      });
    },
    goToHome() {
      this.$router.push({ path: "/" });
    },
    goToPremiere() {
      this.$router.push({ path: "/premiere" });
    },
    goToMenu() {
      this.$router.push({ path: "/menu" });
    },
    loyaltyhowitWorks() {
      this.$router.push({ path: "/LoyaltyHowItWorks" });
    },
    goToMovieDetails: function(data, cat_id) {
      this.displaySearch = false;
      Promise.resolve()
        .then(() => {
          if (this.LanguageID == "1") {
            this.$router.push({
              name: "cinemashowtimes",
              params: {
                cat_id: "1",
                movieId: data.movie_id,

                movieName: data.movie_title
                  ? data.movie_title.replace(/ /g, "-")
                  : data.movie_name.replace(/ /g, "-"),
              },
            });
          } else {
            this.$router.push({
              name: "cinemashowtimes",
              params: {
                cat_id: "1",
                movieId: data.movie_id,

                movieName: data.movie_title
                  ? data.movie_title
                      .toLowerCase()
                      .replace(/[^\w\s]/gi, "")
                      .replace(/ /g, "-")
                  : data.movie_name
                      .toLowerCase()
                      .replace(/[^\w\s]/gi, "")
                      .replace(/ /g, "-"),
              },
            });
          }
        })
        .finally(() => {
          window.location.reload();
        });
    },
    clearSearch() {
      this.searchValue = "";
    },
    onChangeOTP(otp) {
      this.otp = otp;
    },
    saveSelectedCinema(data) {
      this.showLoading();
      if (data && data.CinemaID == "ALL") {
        window.localStorage.setItem("headerCinemaID", "");
        window.localStorage.setItem("headerCinema", "");
      } else {
        window.localStorage.setItem("headerCinemaID", data.CinemaID);
        window.localStorage.setItem("headerCinema", data.CinemaName);
      }

      this.$store.commit("increment");
      this.selectedCinema = data.CinemaName;
      this.selectedCinemaID = data.CinemaID;
      setTimeout(() => {
        this.hideLoading();
      }, 500);
      window.location.pathname = "/";
    },
    saveSelectedCinemaBrij(cinema) {
      this.showLoading();

      if (cinema && cinema.cinema_id == "") {
        Vue.localStorage.remove("brij_cinema");
      } else {
        Vue.localStorage.set("brij_cinema", JSON.stringify(cinema));

        this.$store.commit("SET_BRIJ_SELECTED_CINEMA", cinema);
      }

      setTimeout(() => {
        this.hideLoading();
      }, 500);
      window.location.pathname = "/";
    },

    fetchCinemaList: function() {
      this.cinemaList = [];
      // makeRequest('/GetCinemas', 'POST', null, null)
      //   .then(result => {
      //     const { error, res } = result
      //     const { data } = res.data
      //
      //     if (res.data) {
      //       this.cinemaList = res.data.Categories
      //       let objcinemaAll = {
      //         CinemaName: this.allLanguageData.AllCinemas,
      //         CinemaID: 'ALL',
      //       }
      //
      //       this.cinemaList.unshift(objcinemaAll)
      //     }
      //   })
      //   .catch(error => {
      //     console.log('Error on vue front', error)
      //   })
    },
    onSelectCountry: function(CountryName, CountryID, lang, id) {
      this.CountryName = CountryName;
      let CountryJSON = { CountryID: CountryID };
      CountryService.saveCountry(CountryJSON);
      this.saveLangToken(lang, id);
    },
    saveLangToken: function(lang, id, brij_lang = {}) {
      this.langName = lang;
      let language = {
        lang: lang,
        lang_id: id,
      };
      // this.selectedCinema = "All Cinemas";
      // window.localStorage.setItem("headerCinema", "");
      window.localStorage.setItem("headerCinemaID", "");
      window.localStorage.setItem("headerCinema", "");
      LanguageService.saveLanguage(language, brij_lang);
      this.onClickNext(lang);
    },
    onClickNext(langname) {
      // let lang_id = "";
      // if (langname != "eng" || langname !== "eng") {
      // }

      let lang_id = langname == "ar" ? "ar" : "";

      console.log("this.CountryName", this.CountryName);
      window.localStorage.setItem("CountryName", this.CountryName);
      if (
        window.location.host == "dev.empirecinemas.net" ||
        window.location.host == "empireksadev.binarynumbers.io"
      ) {
        console.log("Local executed");
        window.location.reload();
      } else {
        // alert(`${window.location.protocol}//${window.location.hostname}/ || ${window.location.href.replace(':8082','')}`)
        if (
          `${window.location.protocol}//${window.location.hostname}/` ==
          window.location.href.replace(":8082", "")
        ) {
          window.location.href = "/";
        } else {
          window.location.reload();
        }
        // window.location.reload();
        console.log("Else executed");
        // if (this.CountryName != "") {
        //   this.RedirectURL = `https://${window.location.host}/${lang_id}`;
        //   window.location.replace(`https://${window.location.host}/${lang_id}`);
        //   window.localStorage.setItem("PREIMERE", false);
        // } else {
        //   window.location.pathname = "/";
        // }

        // window.location.replace(`https://dev.empirecinemas.com/${lang_id}`);

        // if (this.CountryName == "Lebanon") {
        //   if (window.location.host == "lb.empirecinemas.com") {
        //     window.location.replace(`https://lb.empirecinemas.com/${lang_id}`);
        //   } else if (window.location.host == "empirepremiere.com") {
        //     window.location.replace(`https://lb.empirecinemas.com/${lang_id}`);
        //   } else if (
        //     window.location.host != "lb.empirecinemas.com" ||
        //     window.location.host != "empirepremiere.com"
        //   ) {
        //     this.RedirectURL = `https://lb.empirecinemas.com/${lang_id}`;
        //     window.location.replace(`https://lb.empirecinemas.com/${lang_id}`);
        //   }
        // } else if (this.CountryName == "Iraq") {
        //   if (window.location.host == "irq.empirecinemas.com") {
        //     window.location.replace(`https://irq.empirecinemas.com/${lang_id}`);
        //     window.localStorage.setItem("PREIMERE", false);
        //   } else if (window.location.host != "irq.empirecinemas.com") {
        //     this.RedirectURL = `https://irq.empirecinemas.com/${lang_id}`;
        //     window.location.replace(`https://irq.empirecinemas.com/${lang_id}`);
        //   }
        // } else if (this.CountryName === "Saudi Arabia") {
        //   if (window.location.host == "ksa.empirecinemas.com") {
        //     window.location.replace(`https://ksa.empirecinemas.com/${lang_id}`);
        //     window.localStorage.setItem("PREIMERE", false);
        //   } else if (window.location.host != "ksa.empirecinemas.com") {
        //     this.RedirectURL = `https://ksa.empirecinemas.com/${lang_id}`;
        //     window.location.replace(`https://ksa.empirecinemas.com/${lang_id}`);
        //   }
        // } else {
        //   window.location.pathname = "/";
        // }
      }
    },

    showMenu: function() {
      this.isMobileMenu = true;
    },
    hideMenu: function() {
      this.isMobileMenu = false;
    },
    switchPopupTab: function(value) {
      if (value == "signup") {
        this.signupTab = true;
        this.loginTab = false;
        this.modal.signUp.info = true;
        this.modal.signUp.OTP = false;
      } else if (value == "login") {
        this.signupTab = false;
        this.loginTab = true;
      }
    },

    hideLoginModal: function() {
      this.$refs["signInModal"].hide();
    },
    onGenderChange: function(value) {
      this.userDetails.gender = value;
    },
    profileDropdownActive() {
      this.isProfileDropdownActive = !this.isProfileDropdownActive;
    },
    homeCallRoute() {
      let getLang = JSON.parse(localStorage.getItem("language"));
      if (getLang.lang_id == 1) {
        this.$router.replace({
          path: "/ar",
        });
      } else {
        this.$router.replace({
          path: "/",
        });
      }
    },
    openLandingpage: function() {
      if (window.location.host.includes("localhost")) {
        // this.$router.push({ path: "/countries" });
        window.location.href = "https://empirecinemas.com";
      } else {
        window.location.href = "https://empirecinemas.com";
      }
    },
    showMobileOfferType: function() {
      this.IsActivedrop = !this.IsActivedrop;
    },
    getAllOffers() {
      makeRequest("/Offerlist", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.Status) {
            this.offerFilterTabs = res.data.OfferType;
          } else {
            console.log("object");
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    isClickedOnNowShowing: function() {
      window.localStorage.removeItem("cinemaD");
    },
    changeProfileTabs: function(type) {
      //  EventBus.$emit("pTabChange", type);
      localStorage.setItem("profileTabType", type);
      this.isProfileDropdownActive = false;
      this.$nextTick(() => {
        this.$router.push({ path: "/profile" });
      });
      // this.$router.push({ path: "/profile" });
    },
    onOTPValue: ({ ...payload }) => {
      // console.log("payload..pratz-1 :>> ", payload);
      // console.log("payload..pratz-2 :>> ", payload.value);
      // this.NewOTP = payload.value;
      // console.log("payload..pratz-3 :>> ", this.NewOTP);
    },
    resetVerifyUserErrors(event) {},
    onInput(formattedNumber, { number, valid, country }) {
      this.userDetails.phoneNumber = formattedNumber;
      this.userDetails.CountryCode = country.dialCode;
      console.log(
        "object :>>this.userDetails.CountryCode",
        this.userDetails.CountryCode
      );
    },
    switchPopupTab: function(value) {
      if (value == "signup") {
        this.signupTab = true;
        this.loginTab = false;
        this.modal.signUp.info = true;
        this.modal.signUp.OTP = false;
      } else if (value == "login") {
        this.signupTab = false;
        this.loginTab = true;
      }
    },
    checkVerified(e) {
      console.log("Change mobile no =>", e);
      if (this.verified.phoneNumber && this.verified.phoneNumber == e) {
        this.isCheckOtpValid = true;
      } else {
        this.isCheckOtpValid = false;
      }
      this.isCheckOtpValid = false;
    },

    showOTPBOx() {
      // this.getUserDetails();

      if (this.userDetails.phoneNumber === "") {
        this.phoneNumberErr = true;
        console.log("mobile err => ", this.phoneNumberErr);
      }
      if (this.userDetails.email === "") {
        this.emailErr = true;
        console.log("Email err => ", this.emailErr);
      }

      if (!this.emailErr && !this.phoneNumberErr) {
        this.checkoutShow = true;

        console.log(this.emailErr + " : " + this.emailErr);

        console.log("User id =>", localStorage.getItem("UserID"));

        if (
          this.verified.phoneNumber &&
          this.verified.phoneNumber != this.userDetails.phoneNumber
        ) {
          this.userDetails.phoneNumber = this.verified.phoneNumber;
          this.isCheckOtpValid = false;
        }

        let payload = {
          MobileNo: this.userDetails.phoneNumber,
          ReserveID: localStorage.getItem("ReserveID"),
          UserID: this.userDetails.userID,
          CountryCode: this.userDetails.countryCode,
          Email: this.userDetails.email,
        };

        console.log("send OTP payload => ", payload);
        makeRequest("/CheckoutOtp", "POST", null, payload)
          .then((result) => {
            const { error, res } = result;
            const { data } = res.data;
            if (!error && res.data.Status) {
              console.log("otp response => ", result);
              this.checkoutShow = false;
              this.otp.value = null;
              this.isSendOtpClicked = true;
              this.isResendOtp = true;
              this.otpResponse = res.data.Message;
            } else {
              // this.$root.$emit("bv::show::modal", "errorModal");
              // show error modal
              console.log("Error => ", error);
              this.checkoutShow = false;
              this.otpResponse = res.data.Message;
              if (res.data.MaxAttempt) {
                this.isSendOtpClicked = false;
              }
            }
            setTimeout(() => (this.otpResponse = ""), 5000);
          })
          .catch((error) => {
            this.checkoutShow = false;
            console.log("Error on vue front", error);
          });
      } else {
        setTimeout(() => {
          this.phoneNumberErr = false;
          this.emailErr = false;
        }, 5000);
        console.log("All fields are required");
      }
    },
    checkoutOtpVerify() {
      console.log("OTP value => ", this.otp.value);
      this.isSendOtpClicked = true;
      let payload = {
        Mobile: this.userDetails.phoneNumber,
        ReserveID: localStorage.getItem("ReserveID"),
        UserID: this.userDetails.userID,
        OTP: this.otp.value,
      };
      console.log("verify OTP payload => ", payload);
      makeRequest("/VerifyCheckoutOtp", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.Status) {
            console.log("otp response => ", result);
            this.otpResponse = res.data.Message;
            this.isCheckOtpValid = true;
            this.isSendOtpClicked = false;
            this.otp.value = null;
            // this.isResendOtp = true;
            (this.verified.phoneNumber = this.userDetails.phoneNumber),
              (this.verified.Email = this.userDetails.Email),
              (this.verified.countryCode = this.userDetails.countryCode);

            console.log("Verified user => ", this.verified);
          } else {
            // this.$root.$emit("bv::show::modal", "errorModal");
            // show error modal
            console.log("Error => ", error);
            if (res.data.MaxAttempt) {
              this.isSendOtpClicked = false;
            }
            this.otpResponse = res.data.Message;
          }

          setTimeout(() => (this.otpResponse = ""), 5000);
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    checkCard: function(card) {
      this.userDetails.selectedCard = card;
    },
    getCountryIsActive() {
      // CountryID != '230' && CountryID != 190 &&  CountryID != 102 && CountryID != '102'
      let array = ["190", "102"];
      return array.indexOf(String(this.CountryID)) === -1;
    },
    getGeoLocation: function() {
      axios
        .get(
          "https://api.ipapi.com/check?access_key=229c548dcafb9cff13041d9544ac60af"
        )
        .then(function(response) {
          // handle success
          // self.countryData = response.data;
          // self.userDetails.countryCode = response.data.country_calling_code.substr(
          //   1
          // );

          showPosition(response.data.latitude, response.data.longitude);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });

      // let self = this;
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(showPosition, showError);
      // } else {
      //   x.innerHTML = "Geolocation is not supported by this browser.1";
      // }

      // function showError(error) {
      //   self.$router.push({
      //     name: "LandingPage"
      //   });
      // }

      function showPosition(lat, long) {
        let _position = {
          latitude: lat,
          longitude: long,
        };

        if (
          (window.localStorage.getItem("Geolocation") == "" ||
            window.localStorage.getItem("Geolocation") == undefined ||
            window.localStorage.getItem("Geolocation") == null) &&
          window.location.host != "empirepremiere.com"
        ) {
          window.localStorage.setItem("Geolocation", JSON.stringify(_position));
          let payload = {
            userLatitude: lat,
            userLongitude: long,
          };

          if (
            window.localStorage.getItem("CountryName") == "" ||
            window.localStorage.getItem("CountryName") == null ||
            window.localStorage.getItem("CountryName") == undefined
          ) {
            makeRequest("/api/GetCountryCityBylatitude", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                console.log("country data", res.data);

                self.CountryName == res.data.LocationInfo.country;

                window.localStorage.setItem(
                  "CountryName",
                  res.data.LocationInfo.country
                );
                if (window.localStorage.getItem("language") == "") {
                  window.localStorage.setItem(
                    "language",
                    JSON.stringify({
                      lang: "eng",
                      lang_id: 2,
                    })
                  );
                }
                window.localStorage.setItem(
                  "country",
                  JSON.stringify({
                    CountryID: res.data.LocationInfo.CountryID,
                  })
                );

                // if (MODE == "dev") {
                //   window.location.pathname = "/";
                // } else {
                if (res.data.LocationInfo.country === "Saudi Arabia") {
                  window.localStorage.setItem(
                    "language",
                    JSON.stringify({
                      lang: "ar",
                      lang_id: 1,
                    })
                  );
                }
                res.data.LocationInfo.country == "Lebanon"
                  ? window.location.replace("https://lb.empirecinemas.com")
                  : res.data.LocationInfo.country == "Iraq"
                  ? (window.location.replace("https://irq.empirecinemas.com"),
                    window.localStorage.setItem("PREIMERE", false))
                  : res.data.LocationInfo.country === "Saudi Arabia"
                  ? (window.location.replace("https://ksa.empirecinemas.com"),
                    window.localStorage.setItem("PREIMERE", false))
                  : ((window.location.href = "https://empirecinemas.com"),
                    window.localStorage.setItem("CountryName", ""));
              })
              .catch((error) => {
                console.log("Error", error);
              });
          }
        } else if (
          window.location.host == "empirepremiere.com" ||
          window.location.host == "lb.empirecinemas.com"
        ) {
          console.log("CountryName", "Lebanon");
          window.localStorage.setItem("CountryName", "Lebanon");
          window.localStorage.setItem(
            "country",
            JSON.stringify({
              CountryID: 119,
            })
          );

          if (window.localStorage.getItem("language") == "") {
            window.localStorage.setItem(
              "language",
              JSON.stringify({
                lang: "eng",
                lang_id: 2,
              })
            );
          }

          if (window.location.host == "empirepremiere.com") {
            window.localStorage.setItem("PREIMERE", true);
          } else if (window.location.host == "lb.empirecinemas.com") {
            window.localStorage.setItem("PREIMERE", false);
          }

          if (
            window.localStorage.getItem("footer") == null ||
            window.localStorage.getItem("footer") == "" ||
            window.localStorage.getItem("footer") == undefined
          ) {
            window.localStorage.setItem("footer", "1");
            window.location.reload();
          }
        } else if (window.location.host == "ksa.empirecinemas.com") {
          console.log("CountryName", "Saudi Arabia");
          window.localStorage.setItem("CountryName", "Saudi Arabia");
          window.localStorage.setItem(
            "country",
            JSON.stringify({
              CountryID: 230,
            })
          );
          if (window.localStorage.getItem("language") == "") {
            window.localStorage.setItem(
              "language",
              JSON.stringify({
                lang: "eng",
                lang_id: 2,
              })
            );
          }

          window.localStorage.setItem("PREIMERE", false);

          if (
            window.localStorage.getItem("footer") == null ||
            window.localStorage.getItem("footer") == "" ||
            window.localStorage.getItem("footer") == undefined
          ) {
            window.localStorage.setItem("footer", "1");
            window.location.reload();
          }
        } else if (window.location.host == "irq.empirecinemas.com") {
          console.log("CountryName", "Iraq");
          window.localStorage.setItem("CountryName", "Iraq");
          window.localStorage.setItem(
            "country",
            JSON.stringify({
              CountryID: 102,
            })
          );
          if (window.localStorage.getItem("language") == "") {
            window.localStorage.setItem(
              "language",
              JSON.stringify({
                lang: "eng",
                lang_id: 2,
              })
            );
          }

          window.localStorage.setItem("PREIMERE", false);

          if (
            window.localStorage.getItem("footer") == null ||
            window.localStorage.getItem("footer") == "" ||
            window.localStorage.getItem("footer") == undefined
          ) {
            window.localStorage.setItem("footer", "1");
            window.location.reload();
          }
        }
      }
    },
    goBackHistory() {
      this.$root.$emit("bv::hide::modal", "sessionTimeOut");
      this.$router.go(-1);
    },
    onClickChange() {
      window.location.href = "https://empirecinemas.com";
    },
    onClickOk: function() {
      this.$router.go(-1);
      this.$refs.errorModal.hide();
    },
    onclickpremiere: function(type) {
      this.showLoading();
      let value = false;

      if (window.location.host == "empirepremiere.com") {
        window.location.replace("http://lb.empirecinemas.com");
      } else {
        window.location.replace("http://empirepremiere.com");
      }
      // if (type == "pre") {
      //   value = true;
      // } else {
      //   value = false;
      // }
      // window.localStorage.setItem("PREIMERE", value);
      // // window.location.reload();
      // window.location.pathname = "/";
      // this.hideLoading();
    },

    onSelectDate: function(value, type) {
      if (type == "date") {
        this.birthDate.date1 = value;
      } else if (type == "month") {
        this.birthDate.month = value;
      } else if (type == "year") {
        this.birthDate.year = value;
      }
      // this.getAge(
      //   this.birthDate.year +
      //     "/" +
      //     this.birthDate.month +
      //     "/" +
      //     this.birthDate.date1
      // );
    },
    closeAdvt: function() {
      this.$root.$emit("bv::hide::modal", "advtModal");
    },
    hideLoginModal: function() {
      this.$refs["signInModal"].hide();
    },
    onChangeGender: function(gender) {
      this.userDetails.gender = gender;
      if (this.userDetails.gender != "Gender") {
        this.errorGender = "";
      }
    },
    openSidenav: function() {
      if (window.localStorage.getItem("cinemaD")) {
        this.isClickedOnNowShowing();
      }
      this.openAside = this.openAside == "0px" ? "-300px" : "0px";
      let el = document.body;
      if (this.openAside == "0px") {
        el.classList.add("oh");
        this.overlay = true;
      } else {
        el.classList.remove("oh");
        this.overlay = false;
      }
    },
    onClickComingSoon() {
      this.openAside = this.openAside == "0px" ? "-300px" : "0px";
      let el = document.body;
      el.classList.remove("oh");
      this.overlay = false;
      $("html,body").animate(
        {
          // scrollTop: $("#comimgSoon").offset().top,
        },
        "slow"
      );
      this.IsActivedrop = false;
    },
    topNavHandler: function() {
      this.openSearch(false);
    },
    openSearch: function(status) {
      console.log(this.$store.state.headerCinemaStore.nowPlayingMovies);
      if (
        this.$store.state.headerCinemaStore.nowPlayingMovies &&
        this.$store.state.headerCinemaStore.nowPlayingMovies.length > 0
      ) {
        this.nowPlayingMoviesArray = this.$store.state.headerCinemaStore.nowPlayingMovies;
      }
      // this.hideSearch = this.hideSearch == "0vh" ? "-100vh" : '0vh';
      this.displaySearch = status;
      if (status == true) {
        document.body.classList.add("search-body-hidden");
      } else {
        document.body.classList.remove("search-body-hidden");
      }
    },
    searchData: function() {
      if (this.searchValue.length > 2) {
        this.movieListSearch = this.SearchMovieData(
          this.allMovies,
          undefined,
          "NowShowing",
          this.searchValue
        );
      } else {
        this.movieListSearch = [];
      }
    },
    callCheckoutEvent: function() {
      console.log("this.userDetails >>>>>>><<<<<<:", this.userDetails);
      // this.$refs.checkoutModal.hide();
      if (this.userDetails.selectedCard === "VisaMaster") {
        this.userDetails.redirectURL = "/RedirectPayment";
      } else if (this.userDetails.selectedCard === "AmericanExpress") {
        this.userDetails.redirectURL = "/RedirectPaymentamax";
      }
      EventBus.$emit("checkOutEvent", this.userDetails);
    },
    checkoutProcess: function() {
      this.handleCheckout = true;
      let token = TokenService.getToken();
      // if (token) {
      if (token && this.loggedInFlag) {
        this.getUserDetails();
        this.$refs.checkoutModal.show();
      } else {
        this.$refs.signInModal.show();
      }
    },
    getCountryCode: function() {
      let self = this;
      //
      axios
        .get("https://ipapi.co/json")
        .then(function(response) {
          // handle success
          self.countryData = response.data;
          // self.userDetails.countryCode = response.data.country_calling_code.substr(
          //   1
          // );
          console.log(response);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    onGoogleSignInSuccess(googleUser) {
      console.log("Google Response >>>>>>>>>>>>>", googleUser);
      // makeRequest(`/app/SocialLogins`, "POST", null, {
      //     socialType: "Google",
      //     socialToken: googleUser.Zi.id_token
      // })
      //     .then(result => {
      //     console.log("Check Socal Google response From here ", result);
      //     const { error, res } = result;
      //     const { data } = res.data;
      //     if (!error && res.data.status && data.result.Status) {
      //         console.log("Social Response >>>>>>", data);
      //         $("#signin-page").modal("hide");
      //         $("#signup-page").modal("hide");
      //         this.userName = data.result.UserName;
      //         EventBus.$emit("UserLogged", {
      //         status: true,
      //         userName: data.result.UserName
      //         });
      //     } else {
      //         this.socialLoginError.error = data.result.Message;
      //         setTimeout(() => {
      //         this.socialLoginError.error = "";
      //         }, 5000);
      //     }
      //     })
      //     .catch(error => {
      //     console.log("Google Login Error", error);
      //     });

      const profile = googleUser.getBasicProfile();
      console.log("Works >>>>>>>>", profile);
      makeRequest(`/SocialLogins`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.wc
          ? googleUser.wc.id_token
          : googleUser.Zi
          ? googleUser.Zi.id_token
          : googleUser.uc
          ? googleUser.uc.id_token
          : googleUser.xc
          ? googleUser.xc.id_token
          : null,
        // stoken: googleUser.Zi.id_token
      })
        .then((result) => {
          // console.log("Check Socal Google response From here ", result);
          // TokenService.saveToken(res.data.access_token);
          this.loginUser(result.res.data.access_token);
          // this.loggedInFlag = true;
          // window.location = "/";
        })
        .catch((error) => {
          console.log("Google Login Error", error);
        });
    },
    onGoogleSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
      this.socialLoginError.error = "Oops, Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },
    onSignFBInSuccess(response) {
      console.log(`onSignFBInSuccess`, response);
      // makeRequest(`/app/SocialLogins`, "POST", null, {
      //     socialType: "Facebook",
      //     socialToken: response.authResponse.accessToken
      // })
      //     .then(result => {
      //     console.log("Check Socal Google response From here ", result);
      //     const { error, res } = result;
      //     const { data } = res.data;
      //     if (!error && res.data.status && data.result.Status) {
      //         console.log("Social Response >>>>>>", data);
      //         this.userName = data.result.UserName;
      //         $("#signin-page").modal("hide");
      //         $("#signup-page").modal("hide");
      //         EventBus.$emit("UserLogged", {
      //         status: true,
      //         userName: data.result.UserName
      //         });
      //     } else {
      //         this.socialLoginError.error = data.result.Message;
      //         setTimeout(() => {
      //         this.socialLoginError.error = "";
      //         }, 5000);
      //     }
      //     })
      //     .catch(error => {
      //     console.log("Google Login Error", error);
      //     });

      makeRequest(`/SocialLogins`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Facebook",
        stoken: response.authResponse.accessToken,
      })
        .then((result) => {
          console.log("Check Socal Facebook response From here ", result);
          // send token to loginuser
          this.loginUser(result.res.data.access_token);
          // result has
        })
        .catch((error) => {
          console.log("Face book Login Error", error);
        });
      FB.api("/me", (data) => {
        console.log("Facebook Data ", data);
      });
    },
    onSignFBInError(error) {
      console.log("OH NOES", error);
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },
    reloadWindow: function() {
      window.location.reload();
    },
    ChangeLoginStatus(isLogin) {},
    hideSignIn: function() {
      this.$refs.signInModal.hide();
    },
    hideSignUp: function() {
      this.$refs.signUpModal.hide();
    },

    onClickBookNow(movieId, formatId) {
      this.$root.$emit("bv::hide::modal", "advtModal");
      this.$router.push({
        name: "movieDetails",
        params: {
          movieId: movieId,
          formatId: formatId,
        },
      });
    },
    validateBeforeSubmit(scope) {
      if (scope == "signIn") {
        this.showLoading();
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            let payload = {
              username: this.userDetails.email,
              password: this.userDetails.password,
              // Mobile: this.userDetails.phoneNumber,
              // CountryCode: this.userDetails.countryCode || "91"
            };
            makeRequest("/UserLoginNew", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.handleCheckout = false;
                  this.loginUser(res.data.access_token);
                  this.modal.signIn.info = false;
                  // this.modal.signIn.OTP = true;
                  if (res.data.hasOwnProperty("LoyaltyCustomerVerfiy")) {
                    localStorage.setItem(
                      "LoyaltyCustomerVerfiy",
                      res.data.LoyaltyCustomerVerfiy
                    );

                    if (
                      res.data.LoyaltyCustomerVerfiy == 0 ||
                      res.data.LoyaltyCustomerVerfiy == "0"
                    ) {
                      EventBus.$emit("openLyoyaltyprogrampopup", true);
                    } else {
                      console.log("object");
                    }
                    EventBus.$emit("getCheckLoyality", true);
                  }
                } else {
                  this.errorMessage.login = res.data.Message;
                }
                this.hideLoading();
              })
              .catch((error) => {
                this.hideLoading();
                console.log("Error", error);
                //   resolve(null);
              });
          }
        });
      }
      if (scope == "signUp") {
        this.showLoading();
        // this.errorDob = "";
        // this.errorGender = "";
        // let count = 0;
        this.$validator
          .validateAll(scope)
          .then((result) => {
            // if (
            //   this.birthDate.date1 == "Date" ||
            //   this.birthDate.month == "Month" ||
            //   this.birthDate.year == "Year"
            // ) {
            //   this.errorDob = "show";
            //   count = 1;
            // }
            // if (this.userDetails.gender == "Gender") {
            //   this.errorGender = "Please Select Gender";
            //   count = 1;
            // }

            // if (count > 0) {
            //   return false;
            // }

            if (result) {
              let payload = {
                Email: this.userDetails.email,
                Mobile: this.userDetails.phoneNumber
                  .trim()
                  .split(" ")
                  .join(""),
                Password: this.userDetails.password,
                RePassword: this.userDetails.confirmedPassword,
                FirstName: this.userDetails.firstName,
                LastName: this.userDetails.lastName,
                Birthdate: this.userDetails.birthDate,
                Gender: this.userDetails.gender,
                newslatteremempirecinemanotification1:
                  this.userDetails.newslatteremempirecinemanotification1 == true
                    ? 1
                    : 0,
                FireBaseID: "",
                // Gender: this.userDetails.gender,
                CountryCode: this.userDetails.CountryCode || "91",
                // Birthdate:
                //   this.birthDate.date1 +
                //   "-" +
                //   this.birthDate.month +
                //   "-" +
                //   this.birthDate.year,
              };
              // console.log("payloadpayloadpayloadpayload EMPNEW :>> ", payload);
              if (this.userDetails.acceptedTerms) {
                makeRequest("/UserRegistrationNew", "POST", null, payload)
                  .then((response) => {
                    console.log("response :", response);
                    const { error, res } = response;
                    if (!error && res.data.Status) {
                      // Switch to OTP section
                      this.modal.signUp.info = false;
                      this.modal.signUp.OTP = true;
                      // this.verifyUser();
                    } else {
                      this.errorMessage.signUp = res.data.Message;
                    }
                  })
                  .catch((error) => {
                    console.log("Error", error);
                    //   resolve(null);
                  });
              } else {
                // Show Message
              }
              this.hideLoading();
              // alert("Form Submitted!");
            } else {
              this.hideLoading();
            }
          })
          .catch((error) => {
            this.hideLoading();
            console.log("on Validation Error", error);
          });
      }
      if (scope == "forgotPasswordEmail") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.errorMessage.forgotpassword = "";
            let payload = {
              email: this.userDetails.email,
            };
            makeRequest("/EmailVerification", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.$refs.forgotpaswordotp.show();
                  this.userDetails.ResetToken = res.data.Data[0].token;
                } else {
                  this.errorMessage.forgotpassword = res.data.Message;
                }
              })
              .catch((error) => {
                console.log("Error", error);
                this.errorMessage.forgotpassword = error;

                //   resolve(null);
              });
            // alert("Form Submitted!");
          }
        });
      }
      if (scope == "forgotPasswordOTP") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.errorMessage.forgotpassword = "";
            let payload = {
              OTP: this.userDetails.OTP,
              ResetToken: this.userDetails.ResetToken,
            };
            makeRequest("/ResetPassOTPVerify", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.$refs.forgotpaswordreset.show();
                } else {
                  this.errorMessage.forgotpassword = res.data.Message;
                }
              })
              .catch((error) => {
                console.log("Error", error);
                this.errorMessage.forgotpassword = error;

                //   resolve(null);
              });
            // alert("Form Submitted!");
            return;
            ``;
          }
        });
      }
      if (scope == "forgotPasswordreset") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.errorMessage.forgotpassword = "";
            let payload = {
              NewPassword: this.userDetails.password,
              ConfirmPassword: this.userDetails.confirmedPassword,
              ResetToken: this.userDetails.ResetToken,
            };
            makeRequest("/ResetPassword", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.$refs.forgotpaswordreset.hide();
                } else {
                  this.errorMessage.forgotpassword = res.data.Message;
                }
              })
              .catch((error) => {
                console.log("Error", error);
                this.errorMessage.forgotpassword = error;

                //   resolve(null);
              });
            // alert("Form Submitted!");
          }
        });
      }
      if (scope == "signUpVerifyOTP") {
        this.verifyUser();
      }
      if (scope == "checkoutUser") {
        this.$validator.validateAll(scope).then((result) => {
          console.log("result :", result);
          // if (result) {
          //   this.callCheckoutEvent();
          // }
          if (result) {
            if (this.countryCode != "230" || this.countryCode != 230) {
              this.userDetails.selectedCard = "VisaMaster";
              this.userDetails.redirectURL = "/RedirectPayment";
              // this.callCheckoutEvent();
            } else {
              this.showCards = false;
              this.hideCards = true;
            }
          }
        });
      }
    },

    verifyUser: function() {
      console.log("Inside the Verify");
      let payload = {
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber
          .trim()
          .split(" ")
          .join(""),
        Password: this.userDetails.password,
        RePassword: this.userDetails.confirmedPassword,
        FirstName: this.userDetails.firstName,
        LastName: this.userDetails.lastName,
        // CountryCode: 91,
        // OTP: "1234", // this.userDetails.OTP,
        OTP: this.userDetails.OTP,
        FireBaseID: "",
        UserName: this.userDetails.email,
      };
      makeRequest("/api/Account/Verifyme", "POST", null, payload)
        .then((response) => {
          console.log("Inside the Verify response", response);
          const { error, res } = response;
          if (!error) {
            if (res.data.Status) {
              localStorage.setItem("LoyaltyCustomerVerfiy", 0);
              this.handleCheckout = false;
              if (
                res.data.LoyaltyCustomerVerfiy == 0 ||
                res.data.LoyaltyCustomerVerfiy == "0"
              ) {
                EventBus.$emit("openLyoyaltyprogrampopup", true);
              } else {
                EventBus.$emit("getCheckLoyality", true);
              }
              this.loginUser(res.data.access_token);
            }
            // handle if error
          }
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
      // alert("Form Submitted!");
    },
    loginUser: function(token) {
      TokenService.saveToken(token);
      this.hideSignIn();
      // this.hideSignUp();
      // this.loggedInFlag = true;
      this.getUserDetails();
      if (this.handleCheckout) {
        this.$refs.checkoutModal.show();
      }

      // fetch token, do api call for profile details save
    },
    getPromotionList: function() {
      makeRequest("/promotion", "POST", null, {})
        .then((result) => {
          const { error, res } = result;
          if (!error && res.status) {
            if (
              res.data &&
              res.data.Advertisement &&
              res.data.Advertisement.length > 0
            ) {
              this.promotionData = res.data.Advertisement[0];
              if (window.location.pathname == "/") {
                this.$root.$emit("bv::show::modal", "advtModal");
              }

              if (this.promotionData) {
                if (
                  sessionStorage.getItem("MODAL") == undefined ||
                  sessionStorage.getItem("MODAL") == null ||
                  sessionStorage.getItem("MODAL") == ""
                ) {
                  sessionStorage.setItem("MODAL", "1");
                  this.$root.$emit("bv::show::modal", "advtModal");
                }
              }
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    // getUserDetails: function (callback) {
    //   let token = TokenService.getToken();
    //   let payload = {};
    //   makeRequest("/ProfileData", "POST", token, payload)
    //     .then((result) => {
    //       const { error, res } = result;
    //       if (!error && res.status) {
    //         this.userDetails.email = res.data.Email;
    //         this.userDetails.phoneNumber = res.data.Mobile;
    //         this.userDetails.userName = res.data.UserName;
    //         this.profileDetails = res.data;
    //         this.loggedInFlag = true;
    //         if (callback) {
    //           callback();
    //         }
    //         //   this.userDetails.profilePic =
    //         //       data.userDetails.ProfileURl.length > 0
    //         //           ? data.userDetails.ProfileURl
    //         //           : "/images/svg/icon-profile.svg";
    //         //   this.loginData.loginInput.email = data.userDetails.Email;
    //       } else {
    //         console.log("error from res", res.message);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error on vue front", error);
    //     });
    // },

    getUserDetails: function(callback) {
      let token = TokenService.getToken();
      let payload = {};
      makeRequestBrij(
        `/api/external/get-customer-details/${token}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          if (!error && res.data.status) {
            // this.profileDetails = res.data.FirstName;
            this.profileDetails = res.data.EmpireData || {};
            this.UserRecords = res.data.Records || {};
            this.userDetails.userID = this.profileDetails.UserID;
            this.userDetails.email = this.profileDetails.Email;
            this.userDetails.phoneNumber = this.profileDetails.Mobile;
            this.userDetails.userName = this.profileDetails.UserName;
            this.userDetails.isUPPLoyaltySubscribe = this.UserRecords[0].upp_loyality_registered;
            // console.log(
            //   this.userDetails.isLoyaltySubscribe,
            //   "this.userDetails.isLoyaltySubscribe"
            // );
            if (res.data.CountryISOCode) {
              let CountryISOText = res.data.CountryISOCode.toUpperCase();
              this.selectedCountry = CountryISOText
                ? CountryISOText.toString()
                : "";
            }
            localStorage.setItem(
              "profile_detail",
              JSON.stringify(this.profileDetails)
            );
            this.loggedInFlag = true;
            console.log(
              "profileDetailsprofileDetails 4444444444444444:>> ",
              this.profileDetails
            );
            if (callback) {
              callback();
            }
            //   this.userDetails.profilePic =
            //       data.userDetails.ProfileURl.length > 0
            //           ? data.userDetails.ProfileURl
            //           : "/images/svg/icon-profile.svg";
            //   this.loginData.loginInput.email = data.userDetails.Email;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    onUserLogout() {
      window.localStorage.removeItem("access_token");
      window.localStorage.removeItem("LoyaltyCustomerVerfiy");
      window.localStorage.removeItem("profile_detail");
      window.localStorage.setItem("changeTabProfile", 0);
      window.location.pathname = "/";
      this.loggedInFlag = false;
      this.isProfileDropdownActive = false;
      smartech("identify", " ");
      smartech("dispatch", "User Logout", {});
    },
    checkToken: function() {
      let token = TokenService.getToken();
      if (token) {
        this.loggedInFlag = true;
      }
    },
  },
};
</script>

<style>
.collapse:not(.show) {
  display: block;
}

.empire-header .router-link-exact-active {
  color: #ce1f2e !important;
}

.empire-header .dropdown-item .router-link-exact-active {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/header.vue